var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowmenustate(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.464768 3.65013C0.0742439 4.04065 0.0742439 4.67382 0.464768 5.06434C0.855293 5.45487 1.48846 5.45487 1.87898 5.06434L4.00028 2.94305L6.1216 5.06437C6.51212 5.45489 7.14529 5.45489 7.53581 5.06437C7.92633 4.67384 7.92633 4.04068 7.53581 3.65016L4.71349 0.827837C4.71147 0.825785 4.70945 0.82374 4.70741 0.821702C4.32299 0.437279 3.70345 0.431273 3.31168 0.803682C3.30546 0.809593 3.2993 0.8156 3.2932 0.821702C3.29319 0.82171 3.29318 0.821719 3.29317 0.821728C3.2931 0.821797 3.29303 0.821866 3.29296 0.821935L0.464768 3.65013Z",
    fill: "#686868"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowmenustate);
export default __webpack_public_path__ + "static/media/arrowmenustate.9e8a84db6fe625e459a50d5a9f45459d.svg";
export { ForwardRef as ReactComponent };